import {
  faEnvelopeOpenText,
  faIdCard,
  faLocationDot,
  faMobileScreen,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import Footer from "../../../components/Footer";
import HeaderInterno from "../../../components/HeaderInterno";



export const Consultores = () => {

  const [consultores, setConsultores] = useState([]);


  const getConsultores = async () => {

    const response = await axios.get(process.env.REACT_APP_API_URL + "vendedores/listar?ativo=1&tipo_vendedor=corporativo")

    if( response.data.status !== 'sucesso') {
      console.error("Erro ao buscar vendedores:", response.data.mensagem);
    }

    return response.data.dados; 
  }

  useEffect(() => {
    getConsultores().then((consultor) => {
      setConsultores(consultor);      
    })
  }, []);

  
  return (
    <>
      <HeaderInterno tituloHeader="Listas de Consultores" />
      <main className="container-principal">
        <div className="container container-pagina-interna clearfix">
          <section className="container-interna-consultores">
            

              {              
                consultores.map((consultor, index) => {
                 return (
                    <div  key={index} className="container-card-consultores">
                    <div className="container-img-consultores">
                      <img
                        src={`${process.env.REACT_APP_PUBLIC_URL}imagens/consultores/${consultor.img}`}
                        alt="Consultor"
                      />
                    </div>
                    <div className="container-dados-consultores">
                      <div className="container-titulo-consultores">
                        <FontAwesomeIcon icon={faIdCard} />
                        <h2>{consultor.nome}</h2>
                      </div>
                      <div className="dados-consultores">
                        <div className="container-item-dados">
                          <FontAwesomeIcon icon={faEnvelopeOpenText} />
                          <p>
                            <span>Email: </span>
                            {consultor.email}
                          </p>
                        </div>

                        <div className="container-item-dados">
                          <FontAwesomeIcon icon={faMobileScreen} />
                          <p>
                            <span>Celular: </span>
                            {consultor.celular}
                          </p>
                        </div>

                        <div className="container-item-dados">
                          <FontAwesomeIcon icon={faLocationDot} />
                          <p>
                            <span>Área de atuação: </span>
                            {consultor.area_atuacao}
                          </p>
                        </div>
                      </div>
                    </div>
                    </div>
                 )
                })                        
              }             
            
            {/*
            <div className="container-card-consultores inverter">
              <div className="container-img-consultores">
                <img
                  src={`${process.env.REACT_APP_PUBLIC_URL}imagens/consultores/foto-consultor02.jpg`}
                  alt="Consultor"
                />
              </div>
              <div className="container-dados-consultores">
                <div className="container-titulo-consultores">
                  <FontAwesomeIcon icon={faIdCard} />
                  <h2>Nome do Consultor</h2>
                </div>
                <div className="dados-consultores">
                  <div className="container-item-dados">
                    <FontAwesomeIcon icon={faEnvelopeOpenText} />
                    <p>
                      <span>Email: </span>
                      teste@teste.com
                    </p>
                  </div>

                  <div className="container-item-dados">
                    <FontAwesomeIcon icon={faMobileScreen} />
                    <p>
                      <span>Celular: </span>
                      (21)99999-99999
                    </p>
                  </div>

                  <div className="container-item-dados">
                    <FontAwesomeIcon icon={faLocationDot} />
                    <p>
                      <span>Área de atuação: </span>
                      Área de atuação: Barra
                    </p>
                  </div>
                </div>
              </div>
            </div>
            */}
          </section>
        </div>

        <Footer />
      </main>
    </>
  );
};
